import Vue from 'vue';
import { get } from 'lodash';

Vue.prototype.__ = (str) => get(window.i18n, str, str);
